import type { OsVersionResourceListResponseV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { OsVersionWithId } from '@ingenico/react-configuration-generator';
import { ascendingSortVersion } from '@ingenico/react-configuration-generator';
import { toString } from 'lodash-es';

export function mapOsVersionsByIdForFormBuilder({ data }: OsVersionResourceListResponseV2Api): OsVersionWithId[] {
  return data
    .map((item) => ({
      id: toString(item.id),
      value: toString(item.versionNumber),
      isDeprecated: item.status === 'DEPRECATED',
    }))
    .sort(ascendingSortVersion());
}
